export default __webpack_public_path__ + "static/media/demo_video.cea66774.mp4";